import React, { useState } from 'react';
import ServicePageArea from '../../../../components/ServiceArea/ServicePageArea';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';

const ServicesArea = () => {
   const [open, setOpen] = useState(false);   
   const setVid = () => {      
      setOpen(true)
   }
   return (
      <>
         {open && (
            <Modal show={open} style={{background: "transparent"}} >
               <ModalVideo channel='youtube' autoplay isOpen={open} videoId="LX2u5Lg3pI0" onClose={() => setOpen(false)} />                 
            </Modal>
         )}

         <section className="tp-service-area-three pt-1 pb-1 " >
            <div className="container">
               {/* <div className="row">
                  <div className="col-12">
                     <div className="section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-delay=".3s">
                        <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20 heading-color-black">Our Best Services</h5>
                        <h2 className="tp-section-title heading-color-black">Quality Cleaning Making <br/>you Much Happy</h2>
                     </div>
                  </div>
               </div> */}
               <div className="row">

                  <div className="col-lg-6">
                     <div className="tp-service-three tp-service-four mb-30 wow fadeInUp" data-wow-delay="1.2s" style={{borderRadius: "10px"}}>
                        <div className="tp-service-three-img" style={{borderRadius: "10px", border: "0.1px solid #8b8788" }}>
                           <img src={`assets/img/service/01.jpeg`} className="img-fluid" alt="img-not-found"/>
                              {/* <div className="tp-service-three-img-icon">
                                 <i className={`flaticon-house-cleaning`}></i>
                              </div> */}
                              {/* <div className="tp-service-three-img-overlay">
                                 <div className="tp-service-three-img-overlay-icon">
                                 <i className={`flaticon-house-cleaning`}></i>
                                 </div>
                              </div> */}
                        </div>
                        <div className="tp-service-three-text fix">
                           <h4 className={ "tp-service-three-title mb-20 heading-color-black-with-hover"}>
                           <a target="_blank" href="https://www.linkedin.com/feed/update/urn:li:activity:6969987019443712000/?updateEntityUrn=urn%3Ali%3Afs_feedUpdate%3A%28V2%2Curn%3Ali%3Aactivity%3A6969987019443712000%29">
                           Account Aggregator
                           <p className="mb-1">Framework</p></a> </h4>
                           <p className="mb-30">Integration of the framework in the digital loan journey, to strengthen & simplify digital lending for MSME borrowers</p>
                           <div className="tp-service-three-text-btn">                              
                              <a target="_blank" style={{borderRadius:"10px"}} className="yellow-btn service__btn" href="https://www.linkedin.com/feed/update/urn:li:activity:6969987019443712000/?updateEntityUrn=urn%3Ali%3Afs_feedUpdate%3A%28V2%2Curn%3Ali%3Aactivity%3A6969987019443712000%29">
                                 Know More</a>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="col-lg-6">
                     <div className="tp-service-three tp-service-four mb-30 wow fadeInUp" data-wow-delay="1.2s" style={{borderRadius: "10px"}}>
                        <div className="tp-service-three-img" style={{borderRadius: "10px", border: "0.1px solid #8b8788" }}>
                           <img src={`assets/img/service/02.jpeg`} className="img-fluid" alt="img-not-found"/>
                              {/* <div className="tp-service-three-img-icon">
                                 <i className={`flaticon-house-cleaning`}></i>
                              </div>
                              <div className="tp-service-three-img-overlay">
                                 <div className="tp-service-three-img-overlay-icon">
                                 <i className={`flaticon-house-cleaning`}></i>
                                 </div>
                              </div> */}
                        </div>
                        <div className="tp-service-three-text fix">
                           <h4 className={ "tp-service-three-title  mb-20 heading-color-black-with-hover"}>
                           <Link to="" onClick={() => setVid(true)} style={{cursor:"pointer"}}>Accelerator</Link>
                           <p className="mb-1">Business Loan</p></h4>
                           
                           <p className="mb-30">Simplifying the fund acquisition for Supply-Chain merchants by accelerating business growth</p>
                           
                           <div className="tp-service-three-text-btn">
                              <Link to="" className="yellow-btn service__btn"  onClick={() => setVid(true)} style={{cursor:"pointer", borderRadius:"10px"}}>
                                 Know More</Link>
                           </div>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </section>
      </>
   );
};

export default ServicesArea;